"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useConnections(query) {
  const { ...rest } = useElements("connections", query);
  return {
    connections: rest.items,
    ...rest
  };
}

export { useConnections };
